import MobileAppSection from './MobileAppSection.view';

export default MobileAppSection;
